module.exports = __webpack_public_path__ + "img/whitedirection-arw.2d8e515f.svg";